import React, { useEffect, useState } from "react";
import { Spin, Modal } from 'antd';
import { Base64 } from "js-base64"

export default ({
    visible = false,
    onCancel = () => { },
    md5Id,
    fileName,
    filePath
}) => {
    const [loading, setLoading] = useState(true);
    const [pdfPage, setPdfPage] = useState(1);
    const [fileInfo, setFileInfo] = useState({
        file: null,  //文件
        fileType: "", //文件类型
        pdfPageNum: 1,  //pdf页数
        fileName: "",  //文件名,
        filePath: "",  //服务器文件名
    })

    const fileTypeArr = ["pdf", "docx", "png", "jpg", "gif"];

    const iframeUrl = `http://49.232.220.38:8012/onlinePreview?url=${encodeURIComponent(Base64.encode(`ftp://82.156.18.158:28267/${filePath}`))}`;
    useEffect(() => {
        let oIframe = document.getElementById("file_frame");
        try {
            oIframe.src = iframeUrl;
            if (!/*@cc_on!@*/0) { //if not IE
                oIframe.onload = function () {
                    setLoading(false)
                };
            } else {
                oIframe.onreadystatechange = function () {
                    if (oIframe.readyState == "complete") {
                        setLoading(false)
                    }
                };
            }
        } catch (err) {
            setLoading(false)
        }

    }, [visible]);


    return <Modal
        visible={visible}
        title={fileName ?? "文件预览"}
        footer={null}
        width={"100%"}
        style={{ top: '15px' }}
        bodyStyle={{ minHeight: "300px", maxHeight: "calc(100vh - 84px)", padding: "10px" }}
        onCancel={() => onCancel()}
    >
        <Spin spinning={loading} tip="文件加载中...">
            <div onContextMenu={(e) => { e.preventDefault() }}>
                {filePath && <iframe
                    id="file_frame"
                    // src={`./iframe.html?openUrl=${iframeUrl}`}
                    // src={iframeUrl}
                    scrolling="yes"
                    frameBorder="0"
                    style={{ width: '100%', height: "calc(100vh - 120px)", overflow: 'visible', border: '1px solid #aaa' }}
                ></iframe>}
            </div>
        </Spin>
    </Modal>
}